export default function ({ store }) {
	store.commit('popups/POPUP_RESET');
}
